
export const adminRoutes = [
   
];
